export default "__VITE_ASSET__C0dsg86X__"